import Cookies from 'js-cookie';
import { get } from 'lodash';
import { GetServerSidePropsResult } from 'next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function Code({ query, referral }): JSX.Element {
  const router = useRouter();
  const promotionCode = get(query, 'code.0') as string;
  const url = `https://www.summerhealth.com/?promotion_code=${promotionCode}`;
  useEffect(() => {
    if (promotionCode) {
      Cookies.set('promotionCode', promotionCode);
      router.push(url);
    }
  }, [query, referral, router, url, promotionCode]);

  return (
    <>
      <Link href={url}>
        Redirecting...
        <br />
        Please click if page doesn&apos;t redirect automatically.
      </Link>
    </>
  );
}

export async function getServerSideProps(
  context,
): Promise<GetServerSidePropsResult<object>> {
  return {
    props: {
      query: context.query,
      referral: context.req.headers?.referer || null,
    },
  };
}
